import { CheckCircleOutlined as CheckCircleOutlineIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";

interface Props {
  /** Short explanation shown under the title */
  description: React.ReactNode;
  /** Optional action area (button, chips) rendered under the description */
  children?: React.ReactNode;
}

/**
 * Centered "No settings needed" hero for integrations without a settings form.
 * An integration that grows one stops qualifying: the heading is a claim about
 * the whole page, so it cannot sit alongside a form.
 */
export const NoSettingsCard = ({ description, children }: Props) => {
  const { t } = useTranslate("Integrations");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
      }}
    >
      <CheckCircleOutlineIcon
        sx={{ fontSize: 48, color: "success.main", mb: 2 }}
      />
      <Typography variant="h6" gutterBottom>
        {t("No settings needed")}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, maxWidth: 420, textAlign: "center" }}
      >
        {description}
      </Typography>
      {children}
    </Box>
  );
};
